// extracted by css-extract-rspack-plugin
export default {"cls1":"usePaperAttachment-cls1_ZGu","cls2":"usePaperAttachment-cls2_jO4 usePaperAttachment-cls1_ZGu"};